import {Lang} from 'yougile-lang'
import {UserEvent} from 'yougile-model'
import {Accounts} from '@client/accounts'

export const getActionNameChangeExecutor = (event: UserEvent): string => {
  if (event.type !== 'executor') {
    return ''
  }

  if (!Array.isArray(event.users)) {
    return ''
  }

  if (event.users.length === 0) {
    return Lang.msg.statsTimeline.statActionChangeExecutorEmpty
  }

  const names = event.users.map(uid => {
    return Accounts.getName(uid)
  })
  if (names.length === 1) {
    return Lang.msg.statsTimeline.statActionChangeExecutor(names[0])
  }

  return Lang.msg.statsTimeline.statActionChangeExecutors(names)
}
